/* Two editorial stories: manual swipe, accessible controls, no autorotation. */
if (!customElements.get('apo-opening-stories')) {
  customElements.define('apo-opening-stories', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.apo-diptych');
      this.cards = [...this.querySelectorAll('.apo-cover')];
      this.controls = this.querySelector('.apo-opening-controls');
      if (!this.track || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.controls.hidden = false;
      this.move = index => {
        if (!matchMedia('(max-width:749px)').matches || !this.cards[index]) return;
        const track = this.track.getBoundingClientRect();
        const card = this.cards[index].getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? card.right - track.right : card.left - track.left,
          behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      };
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('[data-apo-story-index]');
        if (button) this.move(Number(button.dataset.apoStoryIndex));
      }, options);
      this.update = () => {
        const bounds = this.track.getBoundingClientRect();
        const visibleWidths = this.cards.map(card => {
          const r = card.getBoundingClientRect();
          return Math.max(0, Math.min(r.right, bounds.right) - Math.max(r.left, bounds.left));
        });
        const current = visibleWidths.indexOf(Math.max(...visibleWidths));
        this.controls.querySelectorAll('button').forEach((button, index) => {
          if (index === current) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => this.move(this.cards.indexOf(event.target)), options);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}
